"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getUserToken = _interopRequireDefault(require("./getUserToken"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const register = async _ref => {
  let {
    lang,
    name,
    pushSubscription
  } = _ref;
  const {
    endpoint,
    keys
  } = pushSubscription || {};
  const {
    p256dh,
    auth
  } = keys || {};
  const postObj = {};
  if (endpoint) postObj.pushEndpoint = endpoint;
  if (lang) postObj.lang = lang;
  if (p256dh) postObj.pushP256DH = p256dh;
  if (auth) postObj.pushAuth = auth;
  postObj.name = name ? name : navigator && navigator.userAgent ? navigator.userAgent : "";
  postObj.userToken = (0, _getUserToken.default)();
  try {
    const response = await fetch("".concat(process.env.REACT_APP_PATH, "/Micado.WebEngine/Micado.WebEngine.IO.Api.WebPush/RegisterDevice.api"), {
      method: "POST",
      body: JSON.stringify(postObj)
    });
    const data = await response.json();
    const {
      msg
    } = data || {};
    if (msg === "ok") return data;
  } catch (error) {
    console.error("register error:", error);
  }
};
var _default = exports.default = register;